<template>
<div class="chapter">
<div class="inner_page">
<div>
<p style="text-align: center;margin-top:.5em;"><img alt="cover" src="OEBPS/images/tp.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02-tp.vue?1a7c0643